import { render, staticRenderFns } from "./Kicks.vue?vue&type=template&id=5ea8f11d&scoped=true&"
import script from "./Kicks.vue?vue&type=script&lang=js&"
export * from "./Kicks.vue?vue&type=script&lang=js&"
import style0 from "./Kicks.vue?vue&type=style&index=0&id=5ea8f11d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8f11d",
  null
  
)

export default component.exports